import type { LevelOfCareContext } from '../levelOfCare.machine';
import type { ReservationFormMainContext } from '../reservationFormMain.types';

/**
 * True when the user may request an override
 * Applies when validation returned errors,
 *   or the first trip leg uses gurney/bariatric gurney.
 */
export function canReservationBeOverriddenFromContext(
  context: ReservationFormMainContext,
): boolean {
  const errs = context.lastValidationResult?.errors;
  if (errs != null && errs.length > 0) {
    return true;
  }

  const locRef = context.levelOfCareRef;
  if (!locRef) {
    return false;
  }
  const locCtx = locRef.getSnapshot().context as LevelOfCareContext;
  if (locCtx.isGurneySelected?.[0] === true) {
    return true;
  }
  return false;
}
